import Vue from 'vue'

window.$ = window.numeral = require('numeral')

Vue.use({
  install: function(Vue, options){
      Vue.prototype.$numeral = require('numeral');
  }
})
